import { render, staticRenderFns } from "./gamelist.vue?vue&type=template&id=2c1fd118"
import script from "./gamelist.vue?vue&type=script&lang=js"
export * from "./gamelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports